export default function OrganizationPerformancePage() {
  return (
    <>
      <h1>This is Organization Performance Page</h1>
    </>
  );
}